import {
	ePetitionAttachmentDownloadQuery,
	useDownloadPoMutation,
} from '@gov-nx/api';
import type { OnEpetitionAttachmentsDownloadParams } from '@gov-nx/component/common';

export interface ePetititionAttachmentDownloadProps {
	onError?: (
		variables: { petitionId: number; attachmentId: number },
		error: Error
	) => void;
	onSuccess?: (data: OnEpetitionAttachmentsDownloadParams) => void;
}

export const usePetitionAttachmentDownload = (
	props?: ePetititionAttachmentDownloadProps
) =>
	useDownloadPoMutation(ePetitionAttachmentDownloadQuery, {
		onError: (error, variables) => {
			if (props?.onError) {
				props.onError(variables, error);
			}
		},
		onSuccess: async (data) => {
			if (props?.onSuccess) {
				props.onSuccess({
					antivirus: data.antivirus,
					fileName: data.fileName,
					blob: data.blob,
					attachmentId: data.variables.attachmentId,
					petitionId: data.variables.petitionId,
				});
			}
		},
	});
